import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { carsonCityConfig } from "./data";

export default function CarsonCityPage() {
  return <OregonCityPageTemplate config={carsonCityConfig} />;
}